import fetchModels from "@/mixin/store/api/fetchModels";
import axios from "@/plugins/axios";
import pushModel from "@/mixin/store/api/pushModel";
import changeModel from "@/mixin/store/api/changeModel";
import fetchModel from "@/mixin/store/api/fetchModel";

export default {
    actions: {
        fetchEmployeeBonusProducts(context) {
            return fetchModels(context, 'employee_bonus_products', null, 'updateEmployeeBonusProducts');
        },
        fetchEmployeeBonusProduct(context, id) {
            return fetchModel(context, 'employee_bonus_products', id, 'updateEmployeeBonusProduct');
        },
        putEmployeeBonusProduct(context, data) {
            return changeModel(context, 'employee_bonus_products/' + data.id + '/give_bonus', data, 'updateEmployeeBonusProduct')
        },
        searchEmployeeBonusProducts(context, searchItem) {
            let url = "employee_bonus_products?page=" + searchItem.page + '&order[id]=desc';

            if (searchItem.personId) {
                url = url + '&person.id=' + searchItem.personId
            }

            return axios.get(url)
                .then((response) => {
                    console.log(response)
                    let data = {
                        models: response.data['hydra:member'],
                        totalItems: response.data['hydra:totalItems']
                    }
                    context.commit('updateEmployeeBonusProducts', data)

                })
                .catch((err) => {
                    console.log(err)
                })
        },
        pushEmployeeAtWork(context, data) {
            return pushModel(context, 'employee_at_works', data, 'updateEmployeeAtWork')
        }
    },
    mutations: {
        updateEmployeeBonusProducts(state, data) {
            state.employeeBonusProducts = data
        },
        updateEmployeeBonusProduct(state, data) {
            state.employeeBonusProduct = data
        }
    },
    state: {
        employeeBonusProduct: {},
        employeeBonusProducts: {
            models: [],
            totalItems: 0
        }
    },
    getters: {
        getEmployeeBonusProduct(state) {
            return state.employeeBonusProduct
        },
        getEmployeeBonusProducts(state) {
            return state.employeeBonusProducts.models
        },
        getEmployeeBonusProductsTotalCount(state) {
            return state.employeeBonusProducts.totalItems
        }
    },
}
